import { render, staticRenderFns } from "./HeaderB2C.vue?vue&type=template&id=bab910ac&"
import script from "./HeaderB2C.vue?vue&type=script&lang=js&"
export * from "./HeaderB2C.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports